import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import tlp from './unisDefaultOptionOutline.vue';

@Component({
    name: 'DefaultSelect',
    mixins: [tlp],
    components: {},
    filters: {
        filtersName(value: any, filterKey: any) {
            if (value && value[filterKey]) return value[filterKey];
            else return value;
        },
    },
})
export default class UnisDefaultOptionOutline extends Vue {
    @Prop({
        default: null,
    })
    selectdata: any;

    @Prop({
        default: '',
    })
    placeholder: string;

    @Prop({
        default: '',
    })
    value: any;

    @Prop({
        default: '',
    })
    filterKey: string;

    @Prop({
        default: '',
    })
    syncKey: string;

    @Prop({
        default: '',
    })
    returnStructure: string;

    @Prop({
        default: false,
    })
    allowClear: boolean;

    @Prop({
        default: false,
    })
    disabled: boolean;

    @Prop({
        default: '',
    })
    addClass: string;

    @Prop({
        default: false,
    })
    error: any;

    priSelectdata: Array<any> = [];
    isFocused: boolean = false;
    isSelect: boolean = false;
    isHandleBin: boolean = false;
    transitionValue: any = '';

    @Watch('error')
    getError(val: any, oldVal: any) {}

    @Watch('selectdata')
    getSelectdata(val: any, oldVal: any) {
        if (val) {
            this.priSelectdata = val;
        }
        if (this.filterKey && val && val.length > 0) {
            this.assignmentTransitionValue(this.value);
        }
    }

    @Watch('value')
    getValue(val: any, oldVal: any) {
        if (!val) {
            this.transitionValue = '';
        }
        if (this.filterKey && this.selectdata && this.selectdata.length > 0) {
            this.assignmentTransitionValue(val);
        } else {
            this.transitionValue = val;
        }
    }

    private assignmentTransitionValue(value: any) {
        let keyByPriSelectdatas = {};
        this.selectdata.forEach((data: any) => {
            let key = data[this.syncKey];
            keyByPriSelectdatas[key] = data;
        });
        if (keyByPriSelectdatas[value])
            this.transitionValue = keyByPriSelectdatas[value][this.filterKey];
    }

    mounted() {
        if (this.value && typeof this.value == 'object')
            this.transitionValue = this.value[this.filterKey];
        else if (this.filterKey && this.selectdata && this.selectdata.length > 0) {
            this.assignmentTransitionValue(this.value);
        } else {
            this.transitionValue = this.value;
        }
        if (this.selectdata) this.priSelectdata = this.selectdata;
    }

    handleFocus() {
        this.isFocused = true;
        this.isHandleBin = true;
        this.isSelect = true;
    }

    handleBlur(isValidate: any) {
        this.isSelect = false;
        this.isFocused = false;
        this.isHandleBin = false;
    }

    onItemSelect(item: any) {
        this.isSelect = false;
        this.isFocused = false;
        this.isHandleBin = false;
        if (this.returnStructure === 'obj') {
            this.transitionValue = item[this.filterKey];
            this.$emit('input', item);
            this.$emit('emitChoose', item);
            return;
        }
        if (item[this.filterKey]) this.transitionValue = item[this.filterKey];
        else this.transitionValue = item;
        if (item[this.syncKey]) this.$emit('input', item[this.syncKey]);
        else if (item) this.$emit('input', item);
        this.$emit('emitChoose', item);
    }

    onAllowClear() {
        this.transitionValue = null;
        this.$emit('input', null);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/unisDefaultOptionOutline/index.ts